import { Component, Show } from "solid-js";

interface MovementBadgeProps {
  delta: number;
}

const BADGE_BASE = "inline-flex items-center font-mono text-2xs tabular-nums ";

/**
 * Small badge showing how far an item moved in the backlog.
 * Positive delta = moved up (towards higher priority). Negative = moved down.
 * Hidden entirely for zero delta.
 */
export const MovementBadge: Component<MovementBadgeProps> = (props) => {
  return (
    <Show when={props.delta !== 0}>
      <Show
        when={props.delta > 0}
        fallback={
          <span
            role="img"
            class={BADGE_BASE + "text-signal-red"}
            aria-label={`Moved down ${Math.abs(props.delta)} positions`}
          >
            ▼{Math.abs(props.delta)}
          </span>
        }
      >
        <span
          role="img"
          class={BADGE_BASE + "text-signal-green"}
          aria-label={`Moved up ${props.delta} positions`}
        >
          ▲{props.delta}
        </span>
      </Show>
    </Show>
  );
};
